import React, { useCallback, useMemo, useState } from 'react';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import VisibilityIcon from '@material-ui/icons/Visibility';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { handleLike } from '../../App/services';


function LikesAndViewsCount(props) {
  const {
    anchorId,
    isClipStoreContent,
    media: {
      isUserLiked,
      likesCount,
      viewsCount,
      contentId,
      type,
    },
    subscribed,
  } = props;
  const [isLiked, setIsLiked] = useState(isUserLiked);
  const [numberOfLikes, setNumberOfLikes] = useState(likesCount);

  const icon = useMemo(() => {
    if (isLiked) {
      return <FavoriteIcon />;
    }

    return <FavoriteBorderIcon />;
  }, [isLiked]);

  const getCount = useCallback((liked) => {
    if (liked) {
      return numberOfLikes + 1;
    }

    return numberOfLikes - 1;
  }, [numberOfLikes]);

  const updateLikes = useCallback((liked) => {
    setIsLiked(liked);
    setNumberOfLikes(getCount(liked));
  }, [getCount]);

  const handleLikeClick = useCallback(async () => {
    if (!subscribed) {
      return;
    }
    const { data } = await handleLike(anchorId, type, contentId, !isLiked);
    const { isUserLiked: liked } = data?.data || {};
    if (data?.data) {
      updateLikes(liked);
    }
  }, [anchorId, contentId, isLiked, subscribed, type, updateLikes]);

  if (isClipStoreContent) {
    return null;
  }

  return (
    <span className="flex items-center white like-view">
      <div
        className={classnames(
          'flex items-center like-count',
          {
            'liked': isLiked,
            'disable-hover': !subscribed,
          }
        )}
      >
        <button className="flex items-center bg-transparent" onClick={handleLikeClick}>
          {icon}
        </button>
        <p>{numberOfLikes}</p>
      </div>
      <div className="flex items-center view-count">
        <VisibilityIcon />
        <p>{viewsCount}</p>
      </div>
    </span>
  );
}

export default LikesAndViewsCount;

LikesAndViewsCount.propTypes = {
  anchorId: PropTypes.number.isRequired,
  isClipStoreContent: PropTypes.bool.isRequired,
  media: PropTypes.shape({
    isUserLiked: PropTypes.bool.isRequired,
    likesCount: PropTypes.number.isRequired,
    viewsCount: PropTypes.number.isRequired,
    contentId: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  subscribed: PropTypes.bool.isRequired,
};

